import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Set Pages
import { AvailableOrdersComponent } from './available-orders/available-orders.component';
import { OrderInProgressComponent } from './order-in-progress/order-in-progress.component';
import { CompletedOrdersComponent } from './completed-orders/completed-orders.component';
import { ProofreaderProgressComponent } from './proofreader-progress/proofreader-progress.component';

const routes: Routes = [
  { path: 'available-orders',                     component: AvailableOrdersComponent },
  { path: 'order-in-progress',                    component: OrderInProgressComponent },
  { path: 'completed-orders',                     component: CompletedOrdersComponent },
  { path: 'progress',                             component: ProofreaderProgressComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProofreadersRoutingModule { }
